import { Getters, State } from '../types/todo-lists.types';
import { TodoList } from '../../../scripts/api/models/todoList';
import { TodoListItem } from '../../../scripts/api/models/todoListItem';

const getters: Getters = {
    currentTodoList (state: State): null | TodoList {
        return state.currentTodoList;
    },
    todoListById (state: State): (todoList: number) => TodoList | undefined {
        return (todoList: number) => state.todoLists.get(todoList);
    },
    todoLists (state: State): Map<number, TodoList> {
        return state.todoLists;
    },
    todoListsState (state: State): symbol {
        return state.todoListsState;
    },
    currentTodoListItems (state: State): Array<TodoListItem> {
        return state.currentTodoListItems;
    },
};

export default getters;
